"use client";

import { useLayoutEffect, useRef, type ReactNode } from "react";
import { cn } from "@/lib/utils/cn";

const OFFSET_VARIABLE = "--detail-header-offset";

let offsetOwner: HTMLElement | null = null;

export interface DetailPageTopBarProps {
  children: ReactNode;
  className?: string;
}

export function DetailPageTopBar({ children, className }: DetailPageTopBarProps) {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;

    const root = document.documentElement;
    offsetOwner = element;

    const publish = () => {
      if (offsetOwner !== element) return;
      root.style.setProperty(OFFSET_VARIABLE, `${element.offsetHeight}px`);
    };

    publish();
    const observer = new ResizeObserver(publish);
    observer.observe(element);

    return () => {
      observer.disconnect();
      if (offsetOwner !== element) return;
      offsetOwner = null;
      root.style.removeProperty(OFFSET_VARIABLE);
    };
  }, []);

  return (
    <div ref={ref} className={cn("sticky top-0 z-30 bg-white", className)}>
      {children}
    </div>
  );
}
